var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDesktop = function SvgDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v18H16v2h4v2H10v-2h4v-2H0V0zm28 16V2H2v14h26zM3.56 24h22.88L30 29.22V30H0v-.78L3.56 24zm-.31 4h23.5l-1.38-2H4.63l-1.37 2z",
    fillRule: "evenodd"
  })));
};
export default SvgDesktop;